var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97852 13.3019V12.875C9.97852 11.819 10.8614 10.9537 12.1186 10.6982L27.5325 7.3765C27.7937 7.32016 28.0675 7.31293 28.3327 7.35537C28.598 7.39781 28.8476 7.48878 29.0623 7.62128C29.277 7.75377 29.4511 7.92425 29.5711 8.11955C29.6912 8.31486 29.754 8.52978 29.7546 8.74774V10.3132",
    stroke: "#04DB8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7516 18.847V24.5397C29.7516 25.5295 28.9632 26.3607 27.8093 26.6745L25.867 27.2438C23.5804 27.8643 21.2761 26.5023 21.2761 24.5397C21.2708 24.0356 21.4648 23.5432 21.8298 23.1338C22.1949 22.7244 22.7122 22.4193 23.3067 22.2626L27.8093 20.9711C28.9632 20.658 29.7516 19.8368 29.7516 18.847ZM29.7516 18.847V1.91535C29.751 1.8064 29.7193 1.69902 29.6591 1.6015C29.5988 1.50397 29.5116 1.41889 29.4042 1.35282C29.2967 1.28675 29.1718 1.24145 29.0392 1.22042C28.9066 1.19938 28.7697 1.20318 28.6392 1.23151L11.0349 5.04635C10.7279 5.11625 10.4579 5.26556 10.2664 5.47128C10.075 5.67701 9.97276 5.92775 9.97548 6.1849V22.2669M9.97548 22.2669C9.97548 23.2567 9.18708 24.0886 8.03318 24.4017L3.4423 25.6825C2.21688 26.0156 1.5 26.9079 1.5 27.9596C1.5 29.9222 3.84135 31.2721 6.09089 30.6637L8.03318 30.0944C9.18708 29.7813 9.97548 28.9502 9.97548 27.9596V22.2669Z",
    stroke: "#04DB8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic);
export default __webpack_public_path__ + "static/media/IconMusic.b06358620450ea4114499b014de5bfd6.svg";
export { ForwardRef as ReactComponent };